'use client'

import { useState } from 'react'

export interface FAQItem {
  pergunta: string
  resposta: string
}

export interface FAQProps {
  titulo?: string
  items: FAQItem[]
  primaryColor?: string
}

export function FAQ({ titulo, items, primaryColor }: FAQProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0)
  const color = primaryColor || '#7C3AED'

  if (!items || items.length === 0) return null

  return (
    <section className="bg-white py-16 sm:py-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <h2 className="text-2xl sm:text-3xl font-bold text-stone-900 text-center mb-12">
          {titulo || 'Perguntas Frequentes'}
        </h2>
        <div className="space-y-3">
          {items.map((item, i) => {
            const isOpen = openIndex === i
            return (
              <div key={i} className="border border-stone-200 rounded-2xl overflow-hidden">
                <button
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  className="w-full px-5 py-4 text-left flex items-center justify-between hover:bg-stone-50 transition-colors"
                >
                  <span className="font-medium text-stone-900 pr-4">{item.pergunta}</span>
                  <svg
                    className={`w-5 h-5 flex-shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                    style={{ color }}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {isOpen && (
                  <div className="px-5 pb-4 text-sm text-stone-600 leading-relaxed whitespace-pre-wrap">
                    {item.resposta}
                  </div>
                )}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
